module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "social-icons"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3484/dist/assets/img/social-media/icon-facebook.svg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.instagram.com"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3484/dist/assets/img/social-media/icon-instagram.svg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3484/dist/assets/img/social-media/icon-linkedin.svg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.twitter.com"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/3484/dist/assets/img/social-media/icon-twitter.svg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-223e1212","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=2orvgp80z9y!./~/string-replace-webpack-plugin/loader.js?id=fk6phdenes7!./src/components/SocialMedia.vue
// module id = 656
// module chunks = 0